import WithRender from "../templates/layoutImageEditor.html";
import { mapGetters, mapActions } from "vuex";
import "../../styles/layouts/layoutImageEditor.css";

require("../../../libs/oie/jquery-ui-1.11.4");
require("../../../libs/oie/draggable_background");
require("../../../libs/oie/jquery.ui.rotatable");
require("../../../libs/oie/patch_draggable");
require("../../../libs/oie/resizable-rotatable.patch");
require("../../../libs/oie/jquery.pep");
require("../../../libs/oie/cropper");
require("../../../libs/oie/css/cropper.min.css");
require("../../../libs/oie/jquery-cropper");
require("../../../libs/oie/oie_helper");

import ImageEditor from "./imageEditor/ImageEditor";
import ImageEditorGalleries from "./imageEditorGalleries/ImageEditorGalleries";
import Steckdosen from "./imageEditor/Steckdosen";
import CornersEditor from "./imageEditor/CornersEditor";
import Cutouts from "./imageEditor/Cutouts";
import ImageEditorInputs from "./imageEditor/ImageEditorInputs";

export default WithRender({
  components: {
    appImageEditor: ImageEditor,
    appImageEditorGalleries: ImageEditorGalleries,
    appSteckdosen: Steckdosen,
    appCornersEditor: CornersEditor,
    appCutouts: Cutouts,
    appImageEditorInputs: ImageEditorInputs
  },
  computed: {
    ...mapGetters(["getPOIEVariables"])
  },
  created: function () {
    this.$nextTick(
      (function (that) {
        return function () {
          var POIEVariables = that.getPOIEVariables;
          that.$store.commit("changeImageId", POIEVariables.defaults.imageId);
          that.$store.dispatch("initEditor", {});
        };
      })(this)
    );
  }
});
